import React, { useEffect, useRef, useState } from "react";
import { useRecoilState } from 'recoil';
import {
	dayOfServiceState,
	timezoneState,
	urlItinerariesState,
	dateOfServiceState,
	endDateOfServiceState,
	waypointsState,
	dateWeekServiceState,
	weeklyItineraryState,
	keyMapState,
	baseIdState,
	calendarViewState,
	resourceListState,
} from "../recoil/atoms";
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import momentTimezonePlugin from '@fullcalendar/moment-timezone';
import listWeek from '@fullcalendar/list';
import axios from 'axios';
import moment from "moment";
import { colorList } from "./Gmaps";

const CalendarResource = () => {
	const [ dayOfService, setDayOfService ] = useRecoilState( dayOfServiceState );
	const [ timezone, setTimeZone ] = useRecoilState( timezoneState );
	const [ urlItineraries, setUrlItineraries ] = useRecoilState( urlItinerariesState );
	const [ calendarView, setCalendarView ] = useRecoilState( calendarViewState );
	const calendarRef = React.createRef();
	const [ calendarKey, setCalendarKey ] = useState( 0 );
	const [ fetching, setFetching ] = useState( false );
	const [ orders, setOrders ] = useState( undefined );
	const [ resources, setResources ] = useRecoilState( resourceListState );
	const [ itinerary, setItinerary ] = useRecoilState( weeklyItineraryState );
	const [ basePlaceId, setBasePlaceId ] = useRecoilState( baseIdState );
	const [ endDate, setEndDate ] = useRecoilState( endDateOfServiceState );
	const [ currentDate, setCurrentDay ] = useRecoilState( dateOfServiceState );
	const [ currentWeekDate, setCurrentWeekDate ] = useRecoilState( dateWeekServiceState );
	const [ waypoints, setWaypoints ] = useRecoilState( waypointsState );
	const [ key, setKey ] = useRecoilState( keyMapState );
	const [ isOpen, setIsOpen ] = useState( false );
	const [ selectedUser, setSelectedUser ] = useState('');
	const [ prevUser, setPrevUser ] = useState('');
	const [ offsetScroll, setOffsetScroll ] = useState(0);
	const isUpdating = useRef(false);

	const handleChanges = ( info, day, date ) => {
		let _date = moment( date ).format( "YYYY-MM-DD" );
		setCurrentDay( _date );
		setDayOfService( day );
		scrollToTop();
	};

	useEffect( () => {
		if ( calendarRef && calendarRef.current && currentDate ) {

			calendarRef.current
				.getApi()
				.gotoDate( currentDate );
		}
		setCalendarView('resourceTimeGridDay');
	}, [ calendarRef, currentDate ] )

	useEffect( () => {
		if ( calendarRef && calendarRef.current ) {
			if ( calendarRef.current.calendar.state.viewType !== calendarView ) {
				changeView( calendarRef, calendarView );
			}
			// scrollToTop();
		}
	}, [ calendarRef ] )

	// useEffect( () => {
	// 	// scrollToTop();
	// }, [ key ] )

	const changeView = ( dateClickInfo, view ) => {
		setCalendarView( view );
		if ( calendarRef && calendarRef.current ) {
			calendarRef.current
				.getApi()
				.changeView( view, dateClickInfo.date );
			// scrollToTop();
		}
		setKey( key => key + 1 );
	}

	const apiCallItinerary = ( payload, id ) => {
		let link = id === null ? '/itineraries.json' : '/itineraries/' + id + '.json';

		axios( {
			url: link,
			method: id === null ? 'post' : 'put',
			data: payload,
			headers: {
				"Content-Type": "application/json",
				"X-CSRF-Token": document.querySelector( "meta[name='csrf-token']" ).content,
			}
		} )
			.then( response => {
				setTimeout( () => {
					setOrders( undefined );
					setResources([]);
					setItinerary( [] );
				}, 800 )
			} )
			.catch( error => {
				Object.keys(error.response.data).forEach((key) => {
					M.toast( { html: error.response.data[key], displayLength: 4000, classes: 'error' } );
				});
				console.error( 'Error creating orders:', error );
			} );

	}

	const createOrders = ( order ) => {
		if ( !order ) return;

		function extractIds ( orders ) {
			return orders.map( order =>
				order.status === "pre_created" ? { parent_id: order.id } : { id: order.id }
			);
		}

		const updatedOrders = extractIds( order.events );

		if ( order.id === null ) {
			// create case
			const payload = {
				itinerary: {
					status: order.status,
					user_id: order.user.id,
					date: moment( order.date ).format( "MM/DD/YYYY" ),
					approved: false,
					orders_attributes: updatedOrders
				}
			};
			apiCallItinerary( payload, null );
		} else {
			// update case
			const payload = {
				itinerary: {
					status: order.status,
					user_id: order.user.id,
					date: moment( order.date ).format( "MM/DD/YYYY" ),
					approved: order.id !== null ? !order.approved : false,
					id: order.id !== null ? order.id : null,
					orders_attributes: updatedOrders
				}
			};
			apiCallItinerary( payload, order.id );
		}
	};

	function renderButton ( data ) {
		const textButton = data.id === null ? 'Generate' : data.approved ? 'Approved' : 'Approve';
		const classButton = data.approved ? "btn btn-disabled" : "btn btn-success";
		const tooltipButton = data.approved ? 'data-toggle="tooltip" data-placement="top" title="Click to unapprove"' : '';

		const isPastDate = moment(data.date).isBefore() && moment(data.date).format('YYYY-MM-DD') !== moment().format('YYYY-MM-DD');

		if (isPastDate) return `<div class="my-1 approval-actions"></div>`;

		let dataEvents = [];
		let dataLocations = [];
		if (data.events) {
			data.events.map(el => {
				dataEvents.push({
					approved: el.approved,
					status: el.status,
					id: data.id === null ? null : el.id,
					parent_id: data.id === null ? el.id : null,
					itinerary_id: el.itinerary_id,
					resourceId: el.resourceId,
					shift: el.shift,
					crew: el.crew
				})
			})
		}
		if (data.locations) {
			data.locations.map(el => {
				dataLocations.push({
					id: el.id,
					lat: el.lat,
					lng: el.lng,
				})
			})
		}
		let formattedData = {
			...data,
			events: dataEvents,
			orders: data.id === null ? [] : dataEvents,
			locations: dataLocations
		};

		return `<div class="my-1 approval-actions">
			<button 
				${tooltipButton}
				class='${classButton}'
				data-json='${JSON.stringify( formattedData )}'
				onclick='window.handleCalendarButtonClick(event)'
			>${textButton}</button>
		</div>`;
	}

	function renderButtonReassignment ( name ) {
		return `<span class="mx-2"><div onclick='window.handleButtonClickReassignment(${name})' class="fas fa-retweet reassignment"></div>`;
	}

	useEffect( () => {
		window.handleCalendarButtonClick = (event) => {
			const button = event.currentTarget;
			const jsonData = button.getAttribute('data-json');

			createOrders( JSON.parse(jsonData) );
		};

		window.handleButtonClickReassignment = ( user_id ) => {
			// setSelectedUser( user_id );
			setPrevUser( user_id );
			setIsOpen( !isOpen );
			setUserOnShift([]);
			setLoadedShift(false);
		}

		return () => {
			// Cleanup
			delete window.handleCalendarButtonClick;
		};
	}, [] );

	const approveRouteView = ( info ) => {
		let resourceId = info.el.dataset.resourceId,
			header = $( '.fc-resource-cell[data-resource-id="' + resourceId + '"]' );

		let currentItinerary = itinerary.filter(it => +it.resourceId === +resourceId);
		let currentItineraryId = currentItinerary.length ? currentItinerary[0].id : undefined;

		if ( resourceId && ( currentItineraryId || currentItineraryId === null) ) {
			let html = renderButton( currentItinerary[0] );
			const selector = '.fc-resource-cell[data-resource-id="' + resourceId + '"]';
			const selectorName = '.fc-resource-cell[data-resource-id="' + resourceId + '"] .name';
			const approvalSelector = document.querySelector( selector );
			const resourceItem = resources.find(res => +res.id === +resourceId);
			let idx = undefined;
			resources && resources.forEach( ( el, i ) => {
				if ( +resourceId === +el.id ) {
					idx = i;
				}
			} )
			let _color = colorList[ idx ] ? colorList[ idx ] : '#fb043e';
			const shift = currentItinerary[0].shift;
			let reassignmentHtml = currentItinerary[0].events.length > 0 && resources.length > 1 ? renderButtonReassignment(resourceItem.id) : '<span class="mx-2">&nbsp;</span>';

			if ( !document.querySelector( selectorName ) ) {
				header.html( '<div class="name"><span class="shift-'+ shift  +'"></span><a style="color: ' + _color+ '" class="name-link" href="' + resourceItem.url + '?date=' + currentDate + '" target="_blank">' + resourceItem.title + '</a> ' + reassignmentHtml + ' </div>' )
			}

			if ( approvalSelector && approvalSelector.querySelector( '.approval-actions' ) ) {
				return;
			}
			header.append( html );
		}
	}

	const handleEventDrop = ( info, calendar, targetItineraryId ) => {
		const droppedEvent = info.event;
		const newUserId = droppedEvent._def.resourceIds;

		let timezone = $( 'body' ).attr( 'data-timezone' );
		let oldDateShort = moment( info.oldEvent.start ).tz( timezone ).format( 'YYYY-MM-DD' );
		let eventsToday = itinerary.find( el => el.date === oldDateShort );

		const divForScroll = document.querySelector( '.fc-time-grid' );
		const divScroller = document.querySelector( '.fc-scroller' );
		let divScrollerPos = +(getOffset( divScroller ).top);
		let divForScrollPos = +(getOffset( divForScroll ).top);
		if ( divScroller && divForScroll ) {

			let diffOffset = divScrollerPos - divForScrollPos;
			setOffsetScroll( diffOffset );
		}

		if ( eventsToday ) {
			dropOrderEvent( info, calendar, newUserId, targetItineraryId );

			setTimeout( () => {
				setOrders(undefined);
				setItinerary([]);
			}, 800 )
		}
	};

	useEffect( () => {
		if ( calendarView === 'dayGridDay' || calendarView === 'resourceTimeGridDay' ) {
			let currentRoutes = [];
			itinerary.forEach( ( r ) => {
				if ( r.date === currentDate ) {
					currentRoutes = r;
					return r;
				}
			} );
			let _wayPoints = [];
			if ( currentRoutes ) {
				_wayPoints.push( basePlaceId );
			}
			if ( currentRoutes.locations ) {
				currentRoutes.locations.forEach( ( st ) => {
					if ( st.place_id ) {
						_wayPoints.push( st.place_id )
					}
				} );
			}
			setWaypoints( _wayPoints );
		}
		scrollToTop();

	}, [ currentDate, itinerary, calendarView ] )

	function getOffset ( el ) {
		const rect = el.getBoundingClientRect();
		return {
			left: rect.left + window.scrollX,
			top: rect.top + window.scrollY
		};
	}

	let tries = 0;
	const scrollToTop = () => {
		const divForScroll = document.querySelector( '.fc-time-grid' );
		const divScroller = document.querySelector( '.fc-scroller' );

		try {
			let divScrollerPos = +(getOffset( divScroller ).top);
			let divForScrollPos = +(getOffset( divForScroll ).top);
			if ( divScroller && divForScroll ) {

				let diffOffset = divScrollerPos - divForScrollPos;
				if ( diffOffset !== offsetScroll && tries < 300 ) {
					divScroller.scrollTo( {
						top: offsetScroll,
					} );
					tries++;
				}
			}
			document.addEventListener( "scroll", scrollToTop );
		} catch ( e ) {}
	}

	function updateStartTimes ( orders ) {
		if ( orders.length === 0 ) return orders;

		let _orders = [];

		orders.map( ( order ) => {
			_orders.push( {
				...order,
				// editable: !order.approved,
			} )
		} );

		return _orders;
	}
	function getNormalizedBusinessHours(business_hours) {
		// Rule 1: If business_hours is undefined, null or empty
		if (!business_hours || Array.isArray(business_hours) && business_hours.length === 0) {
			return { startTime: "00:00", endTime: "23:59", daysOfWeek: [ 0, 1, 2, 3, 4, 5, 6 ] };
		}

		const { startTime, endTime } = business_hours;

		// Rule 2: If startTime > endTime (overnight)
		if (startTime > endTime) {
			return { startTime: startTime, endTime: "23:59", daysOfWeek: [ 0, 1, 2, 3, 4, 5, 6 ] };
		}

		// Normal case
		return { startTime, endTime, daysOfWeek: [ 0, 1, 2, 3, 4, 5, 6 ] };
	}

	useEffect( () => {
		if ( !fetching && orders === undefined && urlItineraries ) {
			try {
				setFetching( true );
				axios.get(
					urlItineraries + '?start=' + currentDate + '&end=' + currentDate
				)
					.then( ( response ) => {
						const offsetOrders = response.data.orders ? response.data.orders : [];
						let formattedResponse = response.data.users && response.data.users.length > 0 ? response.data.users.map( ( el  ) => {

							return {
								...el,
								id: el.id.toString(),
								title: el.full_name,
								// businessHours: el.business_hours
								businessHours: getNormalizedBusinessHours(el.business_hours)
							}
						} ) : [];

						setResources(formattedResponse);
						setOrders( offsetOrders );

						// successCallback(response.data.orders)
						if ( response.data.itinerary ) {
							setItinerary( response.data.itinerary );
						}
					} )
					.finally( ( response ) => {
						setFetching( false );
					} );
			} catch ( error ) {
				console.error( error );
			}
		}
	}, [ currentDate, urlItineraries, orders ] );

	// Request to delete recurring order
	const deleteRecurringOrder = async ( data ) => {
		if ( isUpdating.current ) return; // Prevent multiple requests
		isUpdating.current = true;
		let recurringOrderModal = $( '#recurringOrderModal' );

		try {
			await axios( {
				method: 'post',
				url: '/destroy_recurring_order.json',
				data: data,
				headers: {
					"Content-Type": "application/json",
					"X-CSRF-Token": document.querySelector( "meta[name='csrf-token']" ).content,
				}
			} ).then( () => {
				M.toast( { html: 'Order deleted successfully', displayLength: 3000, classes: 'success' } );
				setOrders( undefined );

			} ).finally( () => {
				isUpdating.current = false;
				recurringOrderModal.modal( 'hide' );
			} );
		} catch ( error ) {
			showErrorText( error );
		}
	}

	const createRecurringOrder = async ( data ) => {
		if (isUpdating.current) return; // Prevent multiple requests
		isUpdating.current = true;
		let orderModal = $( '#recurringOrderModal' );

		try {
			await axios( {
				method: 'post',
				url: '/orders.json',
				data: data,
				headers: {
					"Content-Type": "application/json",
					"X-CSRF-Token": document.querySelector( "meta[name='csrf-token']" ).content,
				}
			} ).then(()=>{
				M.toast( { html: 'Order created successfully', displayLength: 3000, classes: 'success' } );
				setOrders( undefined );
			}).finally(()=>{
				isUpdating.current = false;
				orderModal.modal( 'hide' );
			});
		} catch ( error ) {
			showErrorText( error );
		}
	};

	const updateOrder = async (data) => {
		if (isUpdating.current) return;
		isUpdating.current = true;

		const id = data.order.order_id;
		let orderModal = $('#orderModal');

		axios({
			method: 'put',
			url: `/orders/${id}.json`,
			data: data,
			headers: {
				"Content-Type": "application/json",
				"X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content,
			}
		})
			.then(() => {
				setTimeout(() => {
					setOrders(undefined);
					setItinerary([]);
					setResources([]);
					// fetchItinerary();
				}, 100);
				M.toast({ html: 'Order updated successfully', displayLength: 3000, classes: 'success' });
			})
			.catch(error => {
				Object.keys(error.response.data).forEach((key) => {
					M.toast({ html: error.response.data[key], displayLength: 3000, classes: 'error' });
				});
				console.error('Error creating orders:', error.response);
			})
			.finally(() => {
				isUpdating.current = false; // Unlock API call after completion
			});

		orderModal.modal('hide');
	};

	useEffect( () => {
		document.body.classList.toggle( 'modal-open', isOpen );
	}, [ isOpen ] )

	const [ userOnShift, setUserOnShift ] = useState([]);
	const [ shiftType, setShiftType ] = useState('day');
	const [ loadedShift, setLoadedShift ] = useState(false);

	const ModalChooseUser = () => {
		const styleModal = {
			"position": "fixed",
			"top": 0,
			"left": 0,
			"zIndex": 400,
			"display": "block"
		}

		useEffect(() => {

			if (userOnShift.length === 0 && !loadedShift) {
				try {
					if ( isUpdating.current ) return;
					isUpdating.current = true;

					const formatted = moment( currentDate ).format( 'MM/DD/YYYY hh:mm A' );
					let url = `crew_on_shift?date_of_service=${formatted}&shift=${shiftType}&lead_only=true`;

					axios( {
						url: url,
						method: 'get',
						headers: {
							"Content-Type": "application/json",
							"X-CSRF-Token": document.querySelector( "meta[name='csrf-token']" ).content,
						}
					} )
						.then( response => {
							let _usersOnShift = response.data;
							let _optionsSelect = [<option
								key={0}
								value={'na'}
								disabled={true}
								checked={true}
								onClick={null}
								className="input-group"
							>-</option>];

							if (_usersOnShift.length) {
								_optionsSelect = [
									..._optionsSelect,
									_usersOnShift.map( res => (
										<option
											key={res.id}
											value={res.id}
											disabled={res.id === prevUser}
											onClick={() => setSelectedUser( res.id )}
											className="input-group"
										>{res.full_name}</option>
									) )
								];
								// setSelectedUser(prevUser);
								setUserOnShift(_optionsSelect);
							} else {
								setUserOnShift( [<option
									key={0}
									value={'na'}
									disabled={true}
									checked={true}
									onClick={null}
									className="input-group"
								>No Users for this Shift</option>] );
								// setSelectedUser('na');
							}
							// $('.custom-select').select2({
							// 	theme: 'bootstrap4', width: '100%'
							// });
						} )
						.catch( error => {
							Object.keys( error.response.data ).forEach( ( key ) => {
								M.toast( { html: error.response.data[ key ], displayLength: 4000, classes: 'error' } );
							} );
							console.error( 'Error creating orders:', error );
						} ).finally( () => {
						isUpdating.current = false;
						setLoadedShift(true);
					} );
				} catch ( e ) {
					console.log(e)
				}
			}
		},[ prevUser, shiftType ])

		const handleSelectUsers = ( e ) => {
			if ( +e.target.value !== +prevUser ) {
				setSelectedUser( e.target.value )
			} else {
				setSelectedUser( '' );
			}
		}

		const handleSelectShift = ( e ) => {
			if ( e.target.value !== shiftType ) {
				setShiftType( e.target.value );
				setLoadedShift( false );
				setUserOnShift([])
				setSelectedUser('');
			}
		}

		const handleApproveSelectedUser = async ( e ) => {
			if ( isUpdating.current ) return;
			isUpdating.current = true;

			function extractOrderIds ( orders ) {
				let _parent_order_ids = [];
				let _order_ids = [];
				orders.map( order =>
					order.status === "pre_created" ? _parent_order_ids.push(order.id) :
						_order_ids.push(order.id)
				);

				return {
					parent_order_ids: _parent_order_ids,
					order_ids: _order_ids,
				}
			}

			const sourceItinerary = itinerary.find( el => +el.resourceId === +prevUser && el.id !== null );
			const targetItinerary = itinerary.find( el => +el.resourceId === +selectedUser && el.id !== null );
			if (sourceItinerary && sourceItinerary.id && selectedUser && +selectedUser !== +prevUser) {
				const url = `/itineraries/${sourceItinerary.id}/reassign.json`;
				const updatedOrders = extractOrderIds( sourceItinerary.events );

				let payload = {
					user_id: selectedUser,
					...updatedOrders
				}
				axios( {
					url: url,
					method: 'post',
					data: payload,
					headers: {
						"Content-Type": "application/json",
						"X-CSRF-Token": document.querySelector( "meta[name='csrf-token']" ).content,
					}
				} )
					.then( response => {
						setTimeout( () => {
							setOrders( undefined );
							setResources( [] );
							setItinerary( [] );
						}, 800 )
					} )
					.catch( error => {
						Object.keys( error.response.data ).forEach( ( key ) => {
							M.toast( { html: error.response.data[ key ], displayLength: 4000, classes: 'error' } );
						} );
						console.error( 'Error creating orders:', error );
						isUpdating.current = false;
					} ).finally( () => {
					isUpdating.current = false;
				} );
			} else if (!targetItinerary ) {
				M.toast( { html: 'Need to generate route', displayLength: 4000, classes: 'error' } );
				isUpdating.current = false;
			}

			setIsOpen( false );
			setUserOnShift([]);
			setLoadedShift( false );
		}

		return <div
			style={styleModal}
			className="choose-user w-100 h-100">
			<div className="overlay"></div>
			<div className="inner">
				<div className="modal" style={{ "display": "block" }}>
					<div className="modal-dialog">
						<div className="modal-content">
							<div className="modal-header">
								<h5>Select User for Reassignment</h5>
								<button
									aria-label="Close"
									className="close"
									data-dismiss="modal"
									type="button"
									onClick={() => {
										setIsOpen( false );
										setUserOnShift([]);
										setLoadedShift(false);
									}}
								>
									<span aria-hidden="true">×</span>
								</button>
							</div>
							<div className="p-3">
								<p></p>
								<div className="row px-3">
									<div className="w-50 pb-3">
										<label htmlFor="select_shift">
											Select Shift
											<select
												name="select_shift"
												id="select_shift"
												className="form-control custom-select select2"
												value={shiftType}
												onChange={handleSelectShift}
											>
												<option value="day">Day</option>
												<option value="night">Night</option>
											</select>
										</label>
									</div>
									<div className="w-50 pb-3">
										<label htmlFor="select_user">
											Select User
											<select
												value={selectedUser ? selectedUser : 'na'}
												name="select_user"
												id="select_user"
												className="form-control custom-select select2"
												onChange={handleSelectUsers}
											>
												{userOnShift}
											</select>
										</label>
									</div>
								</div>
								<div className="d-flex justify-content-end">
									<button
										onClick={() => {
											setIsOpen( false );
											setUserOnShift([]);
											setLoadedShift(false);
										}}
										className="btn btn-outline-primary mx-2"
									>Close
									</button>
									<button
										onClick={handleApproveSelectedUser}
										disabled={selectedUser === prevUser || selectedUser === 'na'}
										className={selectedUser && selectedUser !== prevUser && selectedUser !== 'na' ? "btn btn-primary" : "btn btn-disabled"}
									>Reassign
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	}

	function isWithinBusinessHours(start, end, businessHours) {
		const businessStartTime = new Date(start);
		const businessEndTime = new Date(end);

		try {
			// Set the time to the start and end of business hours
			businessStartTime.setHours(parseInt(businessHours.startTime.split(':')[0]));
			businessStartTime.setMinutes(parseInt(businessHours.startTime.split(':')[1]));
			businessEndTime.setHours(parseInt(businessHours.endTime.split(':')[0]));
			businessEndTime.setMinutes(parseInt(businessHours.endTime.split(':')[1]));

			return start >= businessStartTime && end <= businessEndTime;
		} catch ( e ) {
			return true
		}
	}

	if ( orders === undefined || resources === undefined )
		return <div className="w-100 h-100 d-flex align-items-center justify-content-center ">
			<div className="spinner-border">
				<span className="sr-only">Loading...</span>
			</div>
		</div>;

	return <div className="calendar-routes">

		<FullCalendar
			schedulerLicenseKey='0390038764-fcs-1630597155'
			key={calendarKey}
			plugins={[
				timeGridPlugin,
				dayGridPlugin,
				interactionPlugin,
				momentTimezonePlugin,
				resourceTimeGridPlugin,
				listWeek,
			]}
			resources={resources}
			// slotDuration='01:00'
			// slotMinTime='01:00'
			timeZone={timezone}
			slotWidth={200}
			slotMinWidth={200}
			initialView={calendarView}
			view={calendarView}
			initialDate={currentDate}
			contentHeight={window.mobileCheck() ? 'auto' : 705}
			editable={true}
			droppable={true}
			height={705}
			scrollToTime="08:00:00"
			// scrollTime="08:00:00"
			slotMinTime="08:00:00"
			// slotMaxTime="23:00:00"
			scrollTimeReset={false}
			dayMinWidth={150}
			views={{
				resourceTimeGridDay: {
					titleFormat: {
						weekday: 'long',
						month: 'short',
						day: 'numeric',
						year: 'numeric'
					}
				}
			}}
			customButtons={{
				prevDay: {
					icon: 'fc-icon fc-icon-chevron-left',
					click: function () {
						if ( calendarView === 'resourceTimeGridDay' ) {
							let currentDay = calendarRef.current.calendar.state.currentDate;
							let prevDate = new Date( currentDay );
							prevDate.setDate( prevDate.getDate() - 1 );

							const previousDate = moment( currentDate ).subtract( 1, "day" );
							const formattedDate = previousDate.format( "YYYY-MM-DD" );
							const dayName = previousDate.format( "dddd" ).toLowerCase();


							setEndDate( previousDate );
							setCurrentWeekDate( previousDate );
							setOrders( undefined );
							// changeView( calendarRef, 'resourceTimeGridDay' );

							handleChanges( calendarRef.current, dayName, formattedDate );
						}
					}
				},
				nextDay: {
					icon: 'fc-icon fc-icon-chevron-right',
					click: function () {
						if ( calendarView === 'resourceTimeGridDay' ) {

							const newNextDate = moment( currentDate ).local().add( 1, "day" );

							const nextDay = moment( newNextDate ).local().format( 'dddd' ).toLowerCase();

								setCurrentWeekDate( newNextDate );
								setEndDate( newNextDate );
								setOrders( undefined );
								// changeView( calendarRef, 'resourceTimeGridDay' );

							handleChanges( calendarRef.current, nextDay, newNextDate );
						}
					}
				},
				goToday: {
					text: "Today",
					click: function () {
						let nextDate = new Date();
						let nextDay = nextDate.toLocaleDateString( "en-US", { weekday: "long" } ).toLowerCase();
						let today = moment( nextDate ).format( "YYYY-MM-DD" );

						setCurrentWeekDate( today );
						setEndDate( today );
						setCurrentDay(today);
						setOrders( undefined );

						// changeView( calendarRef, 'resourceTimeGridDay' );
						handleChanges( calendarRef.current, nextDay, nextDate );
					}
				},
				dayDatePicker: {
					text: 'Select Date',
					click: function() {
						if (document.querySelector('input.datepicker-selector')) {
							const datepicker = document.querySelector('input.datepicker-selector');
							datepicker.classList.toggle('show');
						} else {
							const datepicker = document.createElement('input');
							datepicker.type = 'date';
							datepicker.className = 'form-control datepicker-selector show';
							datepicker.style.position = 'absolute';
							datepicker.style.right = '14px';
							datepicker.style.width = '220px';
							datepicker.style.top = '40px';
							datepicker.style.zIndex = '1000';
							currentDate ? datepicker.value = currentDate : null;
							datepicker.click(); // Programmatically open the date picker

							document.querySelector('.fc-header-toolbar').appendChild(datepicker);

							datepicker.addEventListener('change', (e) => {
								const formattedDate = moment( e.target.value ).local().format( 'YYYY-MM-DD' );
								const dayName = moment( e.target.value ).local().format( 'dddd' ).toLowerCase();

								setCurrentWeekDate(e.target.value);
								setEndDate(e.target.value);
								setCurrentDay(e.target.value);
								setOrders(undefined);
								setResources([]);

								// changeView(calendarRef, 'resourceTimeGridDay');
								handleChanges(calendarRef.current, dayName, formattedDate);
							});
						}
					}
				}
			}}
			header={{
				left: 'goToday prevDay,nextDay',
				center: 'title',
				right: 'dayDatePicker'
			}}
			events={orders}
			rerenderDelay={0}
			eventDisplay='list-item'
			eventOrder={"start,status,title"}
			slotDuration="00:30"
			eventRender={function ( info ) {
				renderOrderRoute( info, info.event.extendedProps.duration );
			}}
			eventClick={function ( info ) {
				if ( info.event.extendedProps.status === 'pre_created' ) {
					showRecurringOrderModal( info );

					$( document ).on( 'submit', '#recurringOrderModal', function ( e ) {
						e.preventDefault();
						var data = getRecurringOrderFormData( $( this ) );

						createRecurringOrder( data, this );
					} );

					// Show delete recurring order dialog
					$(document).on('click', '#showDeleteRecurringOrderDialog', function (e) {
						e.preventDefault();
						$(this).parents('.modal-footer').hide();
						$('#deleteRecurringOrderDialog').show();
					});

					// Initiate requests to delete recurring order
					$(document).on('click', '#deleteRecurringOrderDialog button', function (e) {
						e.preventDefault();
						var cancel_recurring = $(this).attr('data-cancel-recurring') === 'true' ? 'true' : '',
							data = deleteRecurringOrderFormData($('#recurringOrderModal'), cancel_recurring);

						deleteRecurringOrder(data);
						$('.modal-footer').show();
						$('#deleteRecurringOrderDialog').hide();

						setTimeout(()=>{
							setOrders(undefined);
							setItinerary( [] );
						}, 500)
					});
				} else {
					showOrderModal( info );

					// Initiate requests to update order on forms submit
					$( document ).on( 'submit', '#orderModal', function ( e ) {
						e.preventDefault();
						var data = getOrderFormData( $( this ) );
						if (!fetching) {
							updateOrder( data );
						}
					} );
				}
			}}
			dayRender={function ( info ) {
				approveRouteView( info )
			}}
			eventDrop={function ( info ) {
				let itineraryId = info.event._def.extendedProps.itinerary_id;
				let approvedItinerary = itinerary.find(it => +it.id === +itineraryId);
				let resId = info.event._def.resourceIds[0];
				let approvedItineraryTarget = itinerary.find(it => +it.resourceId === +resId);
				let targetItineraryId = approvedItineraryTarget.id;
				let timezone = $( 'body' ).attr( 'data-timezone' );

				const droppedStart = moment(info.event.start).tz(timezone).local();
				const droppedEnd = moment(info.event.start).tz(timezone).local().add(info.event._def.extendedProps.duration, 'hours');
				const businessHours = resources.find(el => +el.id === +resId).businessHours;

				if (businessHours && !isWithinBusinessHours(droppedStart, droppedEnd, businessHours)) {
					// Prevent dropping events outside business hours
					M.toast( { html: "Sorry, user does not work in current date/shift", displayLength: 3000, classes: 'error' } );
					info.revert(info); // Revert the event to its original position
					return;
				}

				if (info.event._def.extendedProps.status === "pre_created" && approvedItinerary && approvedItinerary.approved) {
					info.revert(info);
					M.toast( { html: "Please create this order first", displayLength: 3000, classes: 'error' } );
				} else if (approvedItinerary && approvedItinerary.approved || approvedItineraryTarget.approved) {
					info.revert(info);
					M.toast( { html: "Sorry, you can't change approved routes", displayLength: 3000, classes: 'error' } );
				} else {
					handleEventDrop( info, this, targetItineraryId );
				}
			}}
			eventDragStart={function ( info ) {
				$( info.el ).attr( 'data-toggle', '' );
				$( '.tooltip' ).remove();
			}}
			eventReceive={
				function ( info ) {
					dropCreatedOrder( info, this );
				}
			}
			ref={calendarRef}
		/>
		{isOpen && <ModalChooseUser />}
	</div>
}

export default CalendarResource;
